module.exports = __webpack_public_path__ + "img/2021.03.7a6d914a.png";